import { HTMLProps, forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      alignItems: 'center',
      marginBottom: theme.spacing(3),
      gridTemplateColumns: '1fr max-content',
      gridColumnGap: theme.spacing(1),
    },
  });

export interface SidebarSectionHeaderProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SidebarSectionHeader = forwardRef<
  HTMLDivElement,
  SidebarSectionHeaderProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div ref={ref} className={classNames(className, classes.root)} {...rest}>
      {children}
    </div>
  );
});

SidebarSectionHeader.displayName = 'SidebarSection.Header';

export default withStyles(styles)(SidebarSectionHeader);
